<app-basic-modal [status]="resetModalStatus" title="" [modalName]="'reset_password'">
  <app-reset-password-form [idPrefix]="idPrefix"
                           [supportButton]="supportButton"
                           (passwordReset)="onPasswordReset($event)" ></app-reset-password-form>
</app-basic-modal>
